<template>
  <div class="shop-status-wrapper" v-if="show" :class="size">
    <div class="center-box">
      <p class="open-time-text" v-if="size !== 'small' || timeDesc" v-text="timeDesc"></p>
      <div class="shop-status-desc" v-text="statusDesc"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopStatus',
  props: {
    size: {
      type: String,
      required: false,
      default: 'normal', // small normal
    },
    status: {
      type: Number,
      required: true,
    },
    nextTime: String,
  },
  data() {
    return {
      show: false,
      timeDesc: '',
      statusDesc: '',
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let arr = [2, 3, 4, 5]
      this.show = arr.includes(this.status)
      switch(this.status) {
        case 2:
          this.timeDesc = this.nextTime ? `${this.$sprintf(this.$t('开始营业%s') , this.nextTime).replace(/\\n/g, '\n')}` : ''
          this.statusDesc = this.$t('休息中');
          break;
        case 3:
          this.timeDesc = ``
          this.statusDesc = this.$t('超出配送范围');
          break;
        case 4:
          this.timeDesc = ``
          this.statusDesc = this.$t('暂停配送');
          break;
        case 5:
          // 暂停营业
          this.timeDesc = ``
          this.statusDesc = this.$t('休息中');
          break;
      }
    },
  }
}
</script>

<style lang="scss" scoped >
.shop-status-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 18px;
}
.shop-status-wrapper.small {
  background: rgba(0, 0, 0, .5);
}
.center-box {
  margin-top: 54px;
}
.open-time-text {
  margin-bottom: 12px;
  min-height: 20px;
  line-height: 20px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  color: #FFFFFF;
}
.shop-status-desc {
  display: inline-block;
  margin: 0 auto;
  padding: 8px;
  max-width: 136px;
  min-width: 136px;
  text-align: center;
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 16px;
  color: rgba(0,0,0,0.70);
  background: #fff;
  border-radius: 3px;
}
.small.shop-status-wrapper {
  display: table;
  font-size: 14px;
}
.small .center-box{
  margin-top: 0;
  display: table-cell;
  height: 100px;
  vertical-align: middle;
}
.small .shop-status-desc {
  padding: 6px 8px;
  max-width: 114px;
  min-width: 114px;
  font-size: 14px;
}
@media screen and (max-width: 768px){
  .open-time-text {
    margin-bottom: rem(12);
    font-size: rem(32);
  }
  .shop-status-desc {
    padding: rem(12) rem(18);
    max-width: rem(264);
    min-width: rem(164);
    font-size: rem(28);
    border-radius: rem(6);
  }
  .center-box {
    margin-top: rem(88);
  }
}
</style>